import ArticleBlackIcon from "@/User/Assets/Svgs/ArticleBlackIcon.svg";
import HomeIconSVG from "@/User/Assets/Svgs/HomeBlackIcon.svg";
import LogoutBlackIcon from "@/User/Assets/Svgs/LogoutBlackIcon.svg";
import MailIconIcon from "@/User/Assets/Svgs/MailBlackIcon.svg";
import SearchBlackIcon from "@/User/Assets/Svgs/SearchBlackIcon.svg";
import StarIconSVG from "@/User/Assets/Svgs/StarFillPrimaryIcon.svg";
import UserIconSVG from "@/User/Assets/Svgs/UserBlackIcon.svg";
import { RouteName } from "@/User/Constants/routes";
import { router } from "@inertiajs/react";
import route from 'ziggy-js';

export const FavoriteMenu = {
    name: "Favorite",
    show: false,
    labelText: "気になる",
    srcIcon: StarIconSVG,
    isActive: false,
    onClick: () => router.visit(route(RouteName.MyFavoritePage)),
    options: null,
};

export const HomeMenu = {
    name: "Home",
    show: true,
    labelText: "マイページ",
    srcIcon: HomeIconSVG,
    isActive: false,
    onClick: () => router.visit(route(RouteName.IndexPage)),
    options: null,
};

export const MailMenu = {
    name: "Mail",
    show: true,
    isActive: false,
    numberNotifyEmail: 0,
    srcIcon: MailIconIcon,
    onClick: () => router.visit(route(RouteName.MyMessagePage)),
    options: null,
    labelText: "メッセージ",
};

export const DefaultProfileOption = {
    text: "プロフィール 確認・編集",
    onClick: () => router.visit(route(RouteName.MyProfile)),
    notify: null,
    isActive: false
};

export const DefaultOpeningOption = {
    text: "希望条件 確認・編集",
    onClick: () => router.visit(route(RouteName.PreferencePage)),
    notify: null,
    isActive: false
};

export const CurrentJobOption = {
    text: "現職情報 確認・編集",
    onClick: () => router.visit(route(RouteName.CurrentJobPage)),
    notify: null,
    isActive: false
};

export const WorkExperienceOption = {
    text: "職務経歴 確認・編集",
    onClick: () => router.visit(route(RouteName.WorkExperiencePage)),
    notify: null,
    isActive: false
};

export const RegistrationMenu = {
    name: "Registration",
    show: true,
    isActive: false,
    labelText: "登録情報確認",
    mobileLabelText: "登録情報確認・編集",
    srcIcon: UserIconSVG,
    options: [],
};

export const SearchMenu = {
    name: "Search",
    show: true,
    labelText: "案件検索",
    srcIcon: SearchBlackIcon,
    isActive: false,
    options: null,
    onClick: () => router.visit(route(RouteName.SearchPage, {})),
};

export const ArticleMenu = {
    name: "Article",
    show: true,
    labelText: "新着記事",
    srcIcon: ArticleBlackIcon,
    isActive: false,
    onClick: () => router.visit(route(RouteName.ArticlesPage)),
    options: null,
};

export const LogoutMenu = {
    name: "Logout",
    show: false,
    labelText: "ログアウト",
    srcIcon: LogoutBlackIcon,
    isActive: false,
    options: null,
    onClick: () => router.visit(route(RouteName.LogoutPage, {})),
};
